import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from "../../../environments/environment";

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with basic auth credentials if available
        let currentUser = JSON.parse(localStorage.getItem(environment.userLocalStored));
        if (currentUser &&  currentUser.token.access_token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${currentUser.token.access_token}`
                }
            });
        }

        return next.handle(request);
    }
}